type Contact = {
  isPrimaryContact: boolean
  projects?: {
    id: string
  }[]
}
/**
 * Attempts to return the preferred contacts for a given project in this order:
 * 1. Primary contacts for the project
 * 2. Contacts for the project
 * 3. Primary contacts for the company
 * 4. Contacts for the company
 */
export const getPreferredContacts = <T extends Contact[]>(
  contacts: T,
  projectId?: string
): T => {
  if (projectId) {
    const primaryProjectContacts = contacts.filter(
      (c) => c.projects?.some((p) => p.id === projectId) && c.isPrimaryContact
    )
    if (primaryProjectContacts.length) {
      return primaryProjectContacts as T
    }

    const projectContacts = contacts.filter((c) =>
      c.projects?.some((p) => p.id === projectId)
    )

    if (projectContacts.length) {
      return projectContacts as T
    }
  } else {
    const primaryContacts = contacts.filter((c) => c.isPrimaryContact)
    if (primaryContacts.length) {
      return primaryContacts as T
    }
  }

  return contacts
}
